// Обработчики менеджера дашбордов, сохранения и переименования.

import type { DashboardManagerTab } from '../state';
import { neighbourDashboardManagerTab, toggleDashboardVisibility, beginDashboardManagerRename, cancelDashboardDelete, closeDashboardManager, copyDashboardFromManager, currentDashboardKey, deleteDashboardFromManager, finishHeaderRename, loadDashboard, openDashboardManager, renameDashboard, renderDashboardManager, requestDashboardDelete, saveDashboard, selectDashboardManagerTab, startHeaderRename, startNewDashboard, toggleDashboardFavorite } from '../dashboards';
import { controls, element } from '../controls';
import { markDirty, updateDashboardHeading } from '../status';
import { openAutoBuilder } from '../autobuilder';
import { refreshAllWidgets } from '../widgets';
import { setPaletteOpen, setViewMode } from '../workspace';
import { state } from '../state';

export function bindDashboardEvents(): void {
  element('#new-dashboard').addEventListener('click', startNewDashboard);
  element('#save-dashboard').addEventListener('click', () => void saveDashboard());
  element('#refresh-all').addEventListener('click', () => void refreshAllWidgets());
  controls.dashboardManagerButton.addEventListener('click', () => void openDashboardManager());
  controls.emptyDashboardManager.addEventListener('click', () => void openDashboardManager());
  controls.emptyAutoBuilder.addEventListener('click', openAutoBuilder);
  controls.emptyAddWidget.addEventListener('click', () => {
    setViewMode(false);
    setPaletteOpen(true);
  });
  controls.dashboardManagerClose.addEventListener('click', closeDashboardManager);
  controls.dashboardManagerNew.addEventListener('click', () => {
    closeDashboardManager();
    startNewDashboard();
  });
  controls.dashboardManagerSearch.addEventListener('input', renderDashboardManager);
  controls.dashboardManagerTabs.addEventListener('click', (event) => {
    const tab = (event.target as Element).closest<HTMLButtonElement>('[data-dashboard-tab]');
    if (tab) selectDashboardManagerTab(tab.dataset.dashboardTab as DashboardManagerTab);
  });
  controls.dashboardManagerTabs.addEventListener('keydown', (event) => {
    // Стрелки переключают вкладки — стандартное поведение tablist (WAI-ARIA).
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    selectDashboardManagerTab(neighbourDashboardManagerTab(event.key), true);
  });
  controls.dashboardManagerDialog.addEventListener('click', (event) => {
    if (event.target === controls.dashboardManagerDialog) closeDashboardManager();
  });
  controls.dashboardTitleButton.addEventListener('click', startHeaderRename);
  controls.dashboardVisibility.addEventListener('click', () => {
    const id = currentDashboardKey();
    if (id) void toggleDashboardVisibility(id);
  });
  controls.dashboardName.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      void finishHeaderRename(true);
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      void finishHeaderRename(false);
    }
  });
  controls.dashboardName.addEventListener('blur', () => void finishHeaderRename(true));
  controls.dashboardManagerList.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-dashboard-action]');
    if (!button) return;
    const id = button.dataset.dashboardId;
    if (!id) return;
    const action = button.dataset.dashboardAction;
    if (action === 'favorite') void toggleDashboardFavorite(id);
    if (action === 'open') {
      void (async () => {
        await loadDashboard(id);
        if (currentDashboardKey() === id) closeDashboardManager();
      })();
    }
    if (action === 'copy') void copyDashboardFromManager(id);
    if (action === 'visibility') void toggleDashboardVisibility(id);
    if (action === 'rename') beginDashboardManagerRename(id);
    if (action === 'delete') requestDashboardDelete(id);
    if (action === 'confirm-delete') void deleteDashboardFromManager(id);
    if (action === 'cancel-delete') cancelDashboardDelete();
  });
  controls.dashboardManagerList.addEventListener('keydown', (event) => {
    const input = (event.target as Element).closest<HTMLInputElement>('[data-dashboard-rename-input]');
    if (!input) return;
    const id = input.dataset.dashboardRenameInput;
    if (!id) return;
    if (event.key === 'Enter') {
      event.preventDefault();
      void renameDashboard(id, input.value);
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      renderDashboardManager();
    }
  });
  controls.dashboardManagerList.addEventListener('focusout', (event) => {
    const input = (event.target as Element).closest<HTMLInputElement>('[data-dashboard-rename-input]');
    const id = input?.dataset.dashboardRenameInput;
    if (input && id) void renameDashboard(id, input.value);
  });
  controls.dashboardName.addEventListener('input', () => {
    if (state.currentDashboardId || state.currentTemplateId) return;
    updateDashboardHeading();
    markDirty();
  });
  controls.dashboardSelect.addEventListener('change', () => void loadDashboard(controls.dashboardSelect.value));
}
